// removed by extract-text-webpack-plugin
module.exports = {"header":"PrivacyPage--header--3g8Kmrjl","card":"PrivacyPage--card--1ATdy4CX"};


//////////////////
// WEBPACK FOOTER
// ./src/App/account/components/PrivacyPage/PrivacyPage.css
// module id = 1283
// module chunks = 2